module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_8019.54b2145c.png";